enum ListingTypeEnum {
  Colour = 'colour',
  Product = 'product',
}

export default ListingTypeEnum;
